"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestLoginResponseCode = exports.EmailValidationResponseStatus = void 0;
var EmailValidationResponseStatus;
(function (EmailValidationResponseStatus) {
    EmailValidationResponseStatus["VALID"] = "VALID";
    EmailValidationResponseStatus["INVALID"] = "INVALID";
    EmailValidationResponseStatus["SUGGESTION"] = "SUGGESTION";
    EmailValidationResponseStatus["NOT_VALIDATED"] = "NOT_VALIDATED";
    EmailValidationResponseStatus["INVALID_CONDITIONALLY"] = "INVALID_CONDITIONALLY";
    EmailValidationResponseStatus["REQUIRED"] = "REQUIRED";
})(EmailValidationResponseStatus || (exports.EmailValidationResponseStatus = EmailValidationResponseStatus = {}));
var GuestLoginResponseCode;
(function (GuestLoginResponseCode) {
    GuestLoginResponseCode["VALIDATION"] = "VALIDATION";
})(GuestLoginResponseCode || (exports.GuestLoginResponseCode = GuestLoginResponseCode = {}));
//# sourceMappingURL=CustomerEnums.js.map